/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';
import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';
import useMeasure from 'react-use-measure';

const ResizablePanel: React.FC<
  PropsWithChildren<{
    css?: SerializedStyles | SerializedStyles[];
    childrenCss?: SerializedStyles | SerializedStyles[];
    className?: string;
    childrenClassName?: string;
  }>
> = ({ children, css, childrenCss, className, childrenClassName, ...props }) => {
  let [ref, bounds] = useMeasure();
  return (
    <motion.div
      animate={{
        height: bounds.height > 0 ? bounds.height : 'auto',
      }}
      transition={{ type: 'spring', bounce: 0.2, duration: 0.8 }}
      css={css}
      className={className}
      {...props}
    >
      <div ref={ref} className={childrenClassName} css={childrenCss}>
        {children}
      </div>
    </motion.div>
  );
};

export default ResizablePanel;
